import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useI18n } from 'vue-i18n'
	
	import { IonSlides, IonSlide, IonButton, IonIcon } from "@ionic/vue";
	import { defineComponent } from 'vue';
	import { arrowForward } from 'ionicons/icons';
	const __default__ = defineComponent({
		name: 'IntroPage',
		components: { IonSlides, IonSlide, IonButton, IonIcon },
		setup()
		{
			return { arrowForward }
		},
		methods: {
			skipIntroPage()
			{
				localStorage.setItem('skip_intro', '1');
				window.location.href = '/';
			}
		}
	});


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const { t } = useI18n({
		inheritLocale: true,
		useScope: 'global'
	})

return (_ctx: any,_cache: any) => {
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, {
    fullscreen: "",
    "scroll-y": "false"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSlides), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "slide" }, [
                _createElementVNode("img", { src: "/assets/slide-1.png" }),
                _createElementVNode("h2", null, "Welcome"),
                _createElementVNode("p", null, [
                  _createTextVNode(" The "),
                  _createElementVNode("b", null, "ionic conference app"),
                  _createTextVNode(" is a practical preview of the ionic framework in action, and a demonstration of proper code use. ")
                ])
              ], -1)
            ]), undefined, true),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("img", { src: "/assets/slide-2.png" }, null, -1),
              _createElementVNode("h2", null, "What is Ionic?", -1),
              _createElementVNode("p", null, [
                _createElementVNode("b", null, "Ionic Framework"),
                _createTextVNode(" is an open source SDK that enables developers to build high quality mobile apps with web technologies like HTML, CSS, and JavaScript. ")
              ], -1)
            ]), undefined, true),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", { src: "/assets/slide-3.png" }, null, -1),
              _createElementVNode("h2", null, "What is Appflow?", -1),
              _createElementVNode("p", null, [
                _createElementVNode("b", null, "Appflow"),
                _createTextVNode(" is a powerful set of services and features built on top of Ionic Framework that brings a totally new level of app development agility to mobile dev teams. ")
              ], -1)
            ]), undefined, true),
            _: 1
          }),
          _createVNode(_unref(IonSlide), null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/assets/slide-4.png" }, null, -1)),
              _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Ready to Play?", -1)),
              _createVNode(_unref(IonButton), {
                fill: "clear",
                onClickNative: _ctx.skipIntroPage
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createTextVNode("Continue ")),
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(arrowForward),
                    slot: "end"
                  }, null, 8, ["icon"])
                ], undefined, true),
                _: 1
              }, 8, ["onClickNative"])
            ], undefined, true),
            _: 1
          })
        ], undefined, true),
        _: 1
      })
    ], undefined, true),
    _: 1
  }))
}
}

})